const hasUsableGiftId = (giftId) => {
  if (giftId === undefined || giftId === null || giftId === '') return false;
  return Number(giftId) !== 0;
};

export const getBlindboxGiftKey = (gift) => {
  const giftId = gift?.gift_id ?? gift?.giftId;
  if (hasUsableGiftId(giftId)) {
    return `id:${String(giftId)}`;
  }

  const giftName = gift?.gift_name ?? gift?.giftName ?? '';
  return `name:${giftName.trim()}`;
};

const normalizeGift = (gift) => ({
  gift_id: gift?.gift_id ?? gift?.giftId ?? 0,
  gift_name: gift?.gift_name ?? gift?.giftName ?? '',
  gift_price: Number(gift?.gift_price ?? gift?.giftPrice ?? 0),
  gift_img: gift?.gift_img ?? gift?.giftImg ?? null,
  count: Number(gift?.count ?? 0)
});

const sortGifts = (gifts) => {
  return [...gifts].sort((a, b) => {
    const aId = Number(a.gift_id || 0);
    const bId = Number(b.gift_id || 0);
    if (aId !== bId) return bId - aId;

    return String(a.gift_name || '').localeCompare(String(b.gift_name || ''), 'zh-Hans-CN');
  });
};

export const mergeBlindboxGiftList = (gifts = [], incomingGift = null) => {
  const giftMap = new Map();

  const addGift = (gift) => {
    const normalizedGift = normalizeGift(gift);
    const key = getBlindboxGiftKey(normalizedGift);
    const existingGift = giftMap.get(key);

    if (!existingGift) {
      giftMap.set(key, normalizedGift);
      return;
    }

    giftMap.set(key, {
      ...existingGift,
      gift_id: normalizedGift.gift_id || existingGift.gift_id,
      gift_name: normalizedGift.gift_name || existingGift.gift_name,
      gift_price: normalizedGift.gift_price || existingGift.gift_price,
      gift_img: normalizedGift.gift_img || existingGift.gift_img,
      count: Number(existingGift.count || 0) + Number(normalizedGift.count || 0)
    });
  };

  gifts.forEach(addGift);
  if (incomingGift) {
    addGift(incomingGift);
  }

  return sortGifts(Array.from(giftMap.values()));
};

export const normalizeBlindboxStats = (statsByBox = {}) => {
  return Object.entries(statsByBox || {}).reduce((normalizedStats, [boxName, boxData]) => {
    normalizedStats[boxName] = {
      ...boxData,
      blind_gift_price: Number(boxData?.blind_gift_price || 0),
      gifts: mergeBlindboxGiftList(boxData?.gifts || [])
    };
    return normalizedStats;
  }, {});
};

export const applyBlindboxUpdate = (statsByBox = {}, updateData = {}) => {
  const normalizedStats = normalizeBlindboxStats(statsByBox);
  const updateKey = getBlindboxGiftKey(updateData);
  const eventBoxName = updateData.blind_gift_name || '';

  const existingBoxName = Object.entries(normalizedStats).find(([, boxData]) => {
    return (boxData.gifts || []).some((gift) => getBlindboxGiftKey(gift) === updateKey);
  })?.[0];

  const targetBoxName = existingBoxName || eventBoxName;
  if (!targetBoxName) {
    return normalizedStats;
  }

  const currentBox = normalizedStats[targetBoxName] || { blind_gift_price: 0, gifts: [] };
  return {
    ...normalizedStats,
    [targetBoxName]: {
      ...currentBox,
      gifts: mergeBlindboxGiftList(currentBox.gifts || [], updateData)
    }
  };
};
